/**
 * An exception that will be understood by the i18n service
 * @param key The key of the message in the translation file
 * @param defaultMessage The default message to be shown if the key is not found
 * @param severity The severity of the message, can be 'info', 'warning' or 'error'
 */
export class i18nException extends Error {
  constructor(
    key: string,
    defaultMessage: string,
    severity: 'info' | 'warning' | 'error' = 'error',
    type?: string,
    statusCode?: number, // add statusCode
  ) {
    super(defaultMessage);
    this.key = key;
    this.defaultMessage = defaultMessage;
    this.severity = severity;
    this.type = type;
    this.statusCode = statusCode;
  }
  key: string;
  defaultMessage: string;
  severity: string;
  type?: string;
  statusCode?: number; // add statusCode property
}

export class InvalidSchemaException extends Error {}
export class NotFoundException extends Error {}
export class NoApplicationSelectedException extends Error {}

export class InvalidTokenException extends Error {}

export class InvalidIssuerException extends Error {}

export class UpdateException extends Error {}

export class DeleteException extends Error {}
